const CLOUD_NAME = 'essential-living';
const DEFAULT_OPTIONS = {
    audio: null,
    format: 'mp4',
};
export function videoUrl(id, options = {}) {
    const combined = { ...DEFAULT_OPTIONS, ...options };
    let transformations = '';
    if (options.audio) {
        transformations += '/ac_none';
    }
    return `https://res.cloudinary.com/${CLOUD_NAME}/video/upload${transformations}/${id}.${combined.format}`;
}
